import { c as _c } from "react/compiler-runtime";
import type { Property } from '../../../store/types';
import { TypeChip } from '../../shared/inline-edit';
import { FIELD_TYPE_BADGE } from './field-type-options';

// View-only counterpart to ChildPropertiesEditor: the canvas is `inert` when read-only, so
// the ClickToReveal schema editor can never be opened — show the nested schema as static text.
export const PropertyTreePreview = t0 => {
  const $ = _c(4);
  const {
    properties
  } = t0;
  if (properties.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== properties) {
    t1 = properties.map(_temp);
    $[0] = properties;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="mt-1 flex flex-col gap-2 border-l border-tertiary pl-3">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
const PropertyPreviewRow = t0 => {
  const $ = _c(26);
  const {
    property
  } = t0;
  const isObject = property.type === "object" || property.type === "array<object>";
  let t1;
  if ($[0] !== property.enumValues) {
    t1 = new Set((property.enumValues ?? []).map(_temp2).filter(Boolean));
    $[0] = property.enumValues;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = [...t1];
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const enumValues = t2;
  let t3;
  if ($[4] !== property.children) {
    t3 = property.children ?? [];
    $[4] = property.children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const children = t3;
  let t4;
  if ($[6] !== property.name) {
    t4 = <span className="text-snippet-3 text-primary font-mono!">{property.name}</span>;
    $[6] = property.name;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = FIELD_TYPE_BADGE[property.type];
  let t6;
  if ($[8] !== t5) {
    t6 = <TypeChip label={t5} canEdit={false} />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className="flex items-center gap-2">{t4}{t6}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== property.description) {
    t8 = property.description && <span className="text-snippet-3 text-tertiary">{property.description}</span>;
    $[13] = property.description;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== enumValues || $[16] !== property.type) {
    t9 = (property.type === "enum" || property.type === "array<enum>") && enumValues.length > 0 && <div className="flex flex-wrap gap-1 border-l border-tertiary pl-3">{enumValues.map(_temp3)}</div>;
    $[15] = enumValues;
    $[16] = property.type;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== children || $[19] !== isObject) {
    t10 = isObject && children.length > 0 && <div className="mt-1 flex flex-col gap-2 border-l border-tertiary pl-3">{children.map(_temp4)}</div>;
    $[18] = children;
    $[19] = isObject;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
    t11 = <div className="flex flex-col gap-1">{t7}{t8}{t9}{t10}</div>;
    $[21] = t10;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
};
function _temp(property) {
  return <PropertyPreviewRow key={property.id} property={property} />;
}
function _temp2(value) {
  return value.trim();
}
function _temp3(value_0) {
  return <span key={value_0} className="rounded bg-secondary px-1.5 py-0.5 text-snippet-3 text-secondary">{value_0}</span>;
}
function _temp4(child) {
  return <PropertyPreviewRow key={child.id} property={child} />;
}